import {
  clearBetterAuthSession,
  createBetterAuthClient,
  makeBetterAuthStateSubscriber,
  makeGetBetterAuthToken,
} from '@agentic-flow-studio/shared/lib/betterAuthClient';

export const authClient = createBetterAuthClient('skill-viper');

const { getBetterAuthToken, clearBetterAuthTokenCache } = makeGetBetterAuthToken(authClient);

export { getBetterAuthToken };

export const betterAuthStateSubscriber = makeBetterAuthStateSubscriber(authClient);

export function clearSkillViperAuthSession() {
  clearBetterAuthSession('skill-viper');
  clearBetterAuthTokenCache();
}
